import { render, staticRenderFns } from "./FlowyEventsBar.vue?vue&type=template&id=2b50248d"
import script from "./FlowyEventsBar.vue?vue&type=script&lang=js"
export * from "./FlowyEventsBar.vue?vue&type=script&lang=js"
import style0 from "./FlowyEventsBar.vue?vue&type=style&index=0&id=2b50248d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports